var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.tjkExamRecord == null
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("目前考核不存在或考核已经结束。")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCurrent == "Yes"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _vm._v("\n    开始考核，请拨打电话（"),
              _c("font", { attrs: { color: "red" } }, [
                _vm._v(_vm._s(_vm.callPhone))
              ]),
              _vm._v("）完成考核。\n  ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCurrent == "No"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _vm._v(
                "\n    请耐心等待考核，预估考核时间：" +
                  _vm._s(_vm.expectExamineTime) +
                  "，考核电话："
              ),
              _c("font", { attrs: { color: "red" } }, [
                _vm._v(_vm._s(_vm.callPhone))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFinish == "Yes"
        ? _c("div", { staticClass: "tips" }, [
            _vm._v("\n    考核完成，考核结果："),
            _vm.passState == "Passed" ? _c("span", [_vm._v("通过")]) : _vm._e(),
            _vm.passState == "Failed"
              ? _c("span", [_vm._v("未通过")])
              : _vm._e(),
            _vm.passState == "NotExamine"
              ? _c("span", [_vm._v("未考")])
              : _vm._e(),
            _vm.passState == "Loss" ? _c("span", [_vm._v("流失")]) : _vm._e(),
            _vm.passState == "Cancel"
              ? _c("span", [_vm._v("取消资格")])
              : _vm._e(),
            _vm._v("，得分：" + _vm._s(_vm.score) + "分\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("当前考核人员")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.currentlist, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "realName",
              label: "考核人员",
              width: "180",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tjkNumber",
              label: "淘金号",
              width: "180",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否通过", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.passState == "Passed"
                      ? _c("span", [_vm._v("通过")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Failed"
                      ? _c("span", [_vm._v("未通过")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "NotExamine"
                      ? _c("span", [_vm._v("未考")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Loss"
                      ? _c("span", [_vm._v("流失")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Cancel"
                      ? _c("span", [_vm._v("取消资格")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "expectExamineTime",
              label: "预估考核时间",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "score", label: "综合得分", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否完成考核", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isFinish == "Yes" ? [_vm._v("是")] : _vm._e(),
                    _vm._v(" "),
                    scope.row.isFinish == "No" ? [_vm._v("否")] : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            _c("h3", [_vm._v("考核名单")]),
            _vm._v(" "),
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "row-class-name": _vm.tableRowClassName
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "sequence",
                          label: "顺序",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "expectExamineTime",
                          label: "预估考核时间",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否完成考核", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.isFinish == "Yes"
                                  ? [_vm._v("是")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.isFinish == "No"
                                  ? [_vm._v("否")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nuv" }, [
      _c("a", { staticClass: "active", attrs: { href: "#" } }, [
        _vm._v("语音考核")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20d48491", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d48491","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/provider/tjkExamOperator.vue
// module id = 1206
// module chunks = 0